export const AppRoute = {
  HOME: '/home',
  SEARCH: '/search',
  DONATE: '/donate',
  MY_IMPACT: '/my-impact',
  MY_OPPORTUNITY: '/my-opportunity',
  MY_FUNDRAISER: '/my-fundraiser',
  MY_CAMPAIGNS: '/my-campaigns',
  MY_ACHIEVEMENTS: '/my-achievements',
  SIGN_IN: '/sign-in',
  OTP_VERIFY: '/sign-in/2fa',
  SSO_SIGN_IN: '/sign-in/sso',
  SSO_GATEWAY: '/signin/sso/gateway',
  FORGOT_PASSWORD: '/forgot-password',
  NEW_ONBOARDING: '/onboarding',
  PLATFORM_TOUR: '/onboarding/platform-tour',
  ONBOARDING_SUCCESS: '/onboarding/success',
  VOLUNTEER: '/volunteer',
  OPPORTUNITY_DETAILS: '/volunteer/opportunities/:opportunityId',
  FUNDRAISER: '/fundraisers/:fundraiserId',
  CREATE_OPPORTUNITY: '/volunteer/opportunities',
  EDIT_OPPORTUNITY: '/volunteer/opportunities/:opportunityId/edit',
  CREATE_FUNDRAISER: '/fundraisers/create',
  EDIT_FUNDRAISER: '/fundraisers/:fundraiserId/edit',
  CREATE_MATCH_REQUEST: '/match-request/create',
  LOG_VOLUNTEERING_ACTIVITY: '/volunteer/log-activity',
  EDIT_VOLUNTEERING_ACTIVITY: '/volunteer/log-activity/:timeLogId/edit',
  CREATE_CAMPAIGN: '/campaigns',
  CAMPAIGN: '/campaigns/:campaignId',
  EDIT_CAMPAIGN: '/campaigns/:campaignId/edit',
  REQUEST_NONPROFIT: '/request-nonprofit',
  EDIT_ATTENDANCE: '/volunteer/opportunities/:opportunityId/edit-attendance',
  EDIT_SURVEY: '/volunteer/opportunities/:opportunityId/edit-survey',
  SURVEY_RESPONSE: '/volunteer/opportunities/:opportunityId/survey/response',
  ORGANISATIONS: '/organisations',
  FUNDRAISERS: '/fundraisers',
  VOLUNTEERING: '/volunteering',
  GIVING_ACTIONS: '/giving-actions',
  SETTINGS: '/settings',
  SESSION_BRIDGE: '/session-bridge',
  ADYEN_REDIRECT: '/donate/adyen-redirect',
  HOME_ADYEN_REDIRECT: '/home/adyen-redirect',
  ORGANISATIONS_ADYEN_REDIRECT: '/organisations/adyen-redirect',
  SEARCH_ADYEN_REDIRECT: '/search/adyen-redirect',
  FUNDRAISER_ADYEN_REDIRECT: '/fundraisers/:fundraiserId/adyen-redirect',
  CAMPAIGN_ADYEN_REDIRECT: '/campaigns/:campaignId/adyen-redirect',
  AI_SEARCH: '/ai-search',
  AI_SEARCH_THREAD: '/ai-search/:threadId'
}
